import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../core/models/response.model'
import { MatInputModule } from '@angular/material/input'
import { AdressClientModel } from '../../../../core/models/address.model'
import { AddressTypeService } from '../../../../core/services/address/address-type/address-type.service'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { ViaCepService } from '../../../../core/services/address/via-cep/via-cep.service'
import { TaxDocumentTypeService } from '../../../../core/services/tax-document/tax-document-type/tax-document-type.service'

@Component({
  selector: 'tax-document-client-edit-form',
  imports: [
    FormsModule,
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatInputModule,
    MatOption,
    MatSelect,
  ],
  templateUrl: './tax-document-client-edit-form.component.html',
  styleUrl: './tax-document-client-edit-form.component.scss',
  providers: [TaxDocumentTypeService],
  standalone: true,
})
export class TaxDocumentClientEditFormComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
    private taxDocumentTypeService: TaxDocumentTypeService,
  ) {}

  form: FormGroup = new FormGroup({})
  loading: boolean = false

  @Output() response = new EventEmitter()
  @Input() editItem: any = {}
  @Input() personId: number = 0

  listType: any[] = []

  ngOnInit(): void {
    this.getListType()
    this.createForm()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
    }
  }

  private treatmentItem() {
    if (this.checkEdit()) {
      this.form.reset()
      this.fillForm()
    }
  }

  getListType() {
    this.taxDocumentTypeService.listTaxDocumentType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listType = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  checkEdit() {
    if (this.editItem) {
      if (this.editItem.edit) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  fillForm() {
    this.form
      .get('taxDocumentType')
      ?.setValue(this.editItem.data.tipo_documento_id)
  }

  resetForm() {
    this.form.reset()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      taxDocumentType: ['', [Validators.required]],
    })
  }

  createTaxDocument() {
    this.loading = true
    const model = this.createModel()
    this.taxDocumentTypeService.createTaxDocument(model).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.response.emit({ refresh: true, clear: true })
        this.resetForm()
        this.loading = false
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  editTaxDocument() {
    this.loading = true
    const model = this.createModel(true)
    this.taxDocumentTypeService.editTaxDocument(model).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.response.emit({ refresh: true, clear: true })
        this.resetForm()
        this.loading = false
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  cancel() {
    this.response.emit({ refresh: false, clear: true })
    this.resetForm()
  }

  createModel(edit: boolean = false) {
    if (edit) {
      return {
        id: this.editItem.data.id,
        tipoDocFiscalId: this.form.controls['taxDocumentType'].value,
        pessoaId: this.personId,
      }
    } else {
      return {
        pessoaId: this.personId,
        tipoDocFiscalId: this.form.controls['taxDocumentType'].value,
      }
    }
  }
}
